import { Layout } from "antd";
import React from "react";
import { TaskManagement } from "../TaskManagement/TaskManagement";
import "./Tasks.less";
const { Content } = Layout;

export const Tasks = (props) => {
  return (
    <Content className="site-body-layout">
      {/* <TaskList /> */}
      <TaskManagement {...props} />
    </Content>
  );
};
